<cars-reference-input-wrapper [content]="content" [showHovertip]="content?.children?.length < 1">
  <cars-reference-input-children
    [readOnly]="readOnly"
    [content]="inlineReferences"
    [contentId]="content.id"
    [coordinatingConjunction]="'or'"
  ></cars-reference-input-children>
</cars-reference-input-wrapper>
